import styled from 'styled-components';
import media from 'components/mixins/media';
import { transparentize } from 'utils/color';
import { defaultBoxShadowColor } from 'constants/common';
import { secondaryFont, mainFontText, secondaryFontText } from 'components/mixins/typography';
import { Icon, Button } from 'components/common';

export const QuestionPoolWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 105px;

  ${media.mobile`
    padding: 40px 30px;
  `};
`;

export const CourseUserTitle = styled.h3.attrs(() => ({
  'data-test': 'course-user-title'
}))`
  ${mainFontText};
  color: ${props => props.theme.colors.textColor};
  text-decoration: none;
  font-style: normal;
  font-size: 32px;
  line-height: 1.4;
  margin-bottom: 20px;

  ${media.mobile`
    font-size: 30px;
  `};
`;
export const CourseIntroductionText = styled.p.attrs(() => ({
  'data-test': 'course-intro'
}))`
  ${secondaryFontText};
`;
export const QuestionPoolOptionsList = styled.ul.attrs({
  'data-test': 'question-pool-options-list'
})`
  display: flex;
  justify-content: space-between;
  margin: 40px 0 80px;

  ${media.mobile`
    flex-direction: column;
    margin-bottom: 20px;
  `};
`;
export const QuestionPoolOptionListItem = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 32%;
  min-height: 146px;
  padding: 24px;
  border-radius: 24px;
  box-shadow: 0 4px 16px 0 ${transparentize(defaultBoxShadowColor, 0.06)};

  ${media.mobile`
    width: 100%;    
    padding: 20px;
    margin-bottom: 20px;
    min-height: 104px;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  `};
`;
export const QuestionPoolOptionIcon = styled(Icon)``;
export const QuestionPoolOptionText = styled.p`
  ${secondaryFont};
  display: flex;
  align-items: center;
  color: ${props =>
    transparentize(props.theme.colors.textColor, props.theme.themeUtils.getOpacity(true, 0.7))};
  font-size: 18px;
  line-height: 1;
  ${media.mobile`
    margin-left: 20px;
  `};
`;
export const QuestionPoolSubText = styled.strong`
  font-size: 26px;
  font-weight: 600;
  margin-right: 6px;
  color: ${props => transparentize(props.theme.colors.textColor, 1)};
`;

type CourseStartButtonProps = {
  tabIndex: string;
  id: string;
};

export const CourseStartButton = styled(Button).attrs((props: CourseStartButtonProps) => ({
  'data-test': 'course-start-button',
  tabIndex: props.tabIndex
}))`
  align-self: flex-start;
  margin-top: 40px;
  font-size: 14px;
  &:focus {
    outline: 1px solid black;
  }
  &:focus:not(:focus-visible) {
    outline: none;
  }

  ${media.mobile`
    font-size: 14px;
    line-height: 1;
    width: 85%;
    position: fixed;
    bottom: 5%;
    margin: 0 auto;
    align-self: center;
  `};
`;
